import React from "react";
import { format } from "lib/globalize-util";
import { getLocalized } from "helpers/transifex/helpers";
import { ConfirmDialog } from "components/dialog";
import { IModalProps } from "../common";
import { styles } from "./styles";
import { DATATEST } from "constants/integration";

export const deleteSelectedPromotions = "Would you like to delete selected promotions?";
export const deleteOneSelectedPromotion = "Would you like to delete this promotion entirely?";
export const promotionsWillBeDeleted = "Promotions will be deleted";
export const onePromotionWillBeDeleted = "Promotion will be deleted";
export const deletePromotionsConfirmation = "Yes, Delete Promotions";
export const deleteOnePromotionConfirmation = "Yes, Delete Promotion";

export const DeleteConfirmationModal: React.FC<IModalProps> = ({
    open,
    onConfirm,
    onClose,
    isBulkAction,
    useTransifex = false,
}) => {
    const text = useTransifex
        ? isBulkAction
            ? getLocalized(
                  "brand.admin.promotions.delete_confirmation_modal.delete_selected_promotions",
                  "DeleteConfirmationModal - dialog text - bulk delete selected promotions",
              )
            : getLocalized(
                  "brand.admin.promotions.delete_confirmation_modal.delete_one_selected_promotion",
                  "DeleteConfirmationModal - dialog text - delete one selected promotion",
              )
        : isBulkAction
          ? format(deleteSelectedPromotions)
          : format(deleteOneSelectedPromotion);

    const title = useTransifex
        ? isBulkAction
            ? getLocalized(
                  "brand.admin.promotions.delete_confirmation_modal.promotions_will_be_deleted",
                  "DeleteConfirmationModal - dialog title - bulk promotions will be deleted",
              )
            : getLocalized(
                  "brand.admin.promotions.delete_confirmation_modal.one_promotion_will_be_deleted",
                  "DeleteConfirmationModal - dialog title - one promotion will be deleted",
              )
        : isBulkAction
          ? format(promotionsWillBeDeleted)
          : format(onePromotionWillBeDeleted);

    const label = useTransifex
        ? isBulkAction
            ? getLocalized(
                  "brand.admin.promotions.delete_confirmation_modal.delete_promotions_confirmation",
                  "DeleteConfirmationModal - confirm button - bulk delete promotions",
              )
            : getLocalized(
                  "brand.admin.promotions.delete_confirmation_modal.delete_one_promotion_confirmation",
                  "DeleteConfirmationModal - confirm button - delete one promotion",
              )
        : isBulkAction
          ? format(deletePromotionsConfirmation)
          : format(deleteOnePromotionConfirmation);

    const cancelLabel = useTransifex
        ? getLocalized(
              "brand.admin.promotions.delete_confirmation_modal.cancel",
              "DeleteConfirmationModal - cancel button - cancel action",
          )
        : format("Cancel");

    const proceedText = useTransifex
        ? getLocalized(
              "brand.admin.promotions.delete_confirmation_modal.are_you_sure_proceed",
              "DeleteConfirmationModal - dialog text - are you sure you want to proceed",
          )
        : format("Are you sure you want to proceed?");

    return (
        <ConfirmDialog
            dataTestConfirm={DATATEST.PROMOTIONS.DELETE_MODAL_DIALOG_CONFIRM}
            dataTestCancel={DATATEST.PROMOTIONS.DELETE_MODAL_DIALOG_CANCEL}
            open={open}
            onConfirm={onConfirm}
            onCancel={onClose}
            onRequestClose={onClose}
            contentStyle={styles.confirmDialog}
            title={title}
            cancelLabel={cancelLabel}
            confirmLabel={label}
        >
            {text}&nbsp;
            {proceedText}
        </ConfirmDialog>
    );
};
